export class NonceToken {
    token = "";

    constructor() {
        this.getTokenFromTemplate();
    }

    getNonceToken = () => {
        return this.token;
    };

    setNonceToken = (value) => {
        if (value !== this.token) this.token = value;
    };

    getTokenFromTemplate = () => {
        if (reactConfig) this.setNonceToken(reactConfig.nonce);
    };
}
